"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FeaturedArticle() {
  const { t, currentLang } = useLanguage();
  const isEs = currentLang === "es";

  return (
    <section className="bg-[#064e3b] text-white">
      <div className="mx-auto flex max-w-7xl flex-col md:flex-row">
        <div className="md:w-[60%]">
          <img
            src="https://placehold.co/600x400/064e3b/fbbf24?text=Repair+Pricing+Guide"
            alt={String(t("blog.featured.title"))}
            className="h-[300px] w-full object-cover md:h-full"
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                "https://placehold.co/600x400/064e3b/fbbf24?text=Pricing";
            }}
          />
        </div>
        <div className="flex flex-col justify-center p-8 md:w-[40%] md:p-10">
          <span className="mb-3 inline-block self-start rounded bg-[#fbbf24] px-3 py-1 text-xs font-bold uppercase tracking-widest text-[#064e3b]">
            {t("blog.featured.tag")}
          </span>
          <h2 className="mb-4 text-3xl font-bold leading-tight">
            {t("blog.featured.title")}
          </h2>
          <p className="mb-6 text-base leading-relaxed italic text-white/70">
            {t("blog.featured.excerpt")}
          </p>
          <Link
            to={isEs ? "/es/blog/costo-reparacion-ventanas-miami/" : "/blog/window-repair-cost-miami/"}
            className="inline-block self-start border-b border-white pb-1 text-base font-semibold text-white transition hover:border-[#fbbf24] hover:text-[#fbbf24]"
          >
            {t("blog.featured.cta")}
          </Link>
        </div>
      </div>
    </section>
  );
}